module.exports = __webpack_public_path__ + "img/c03_unitramchampion_Normal_ua.58bcc0f7.webp";